import { doc, getDoc } from "firebase/firestore";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import Failure from "../../../core/Failure";
import { IContact } from "@leedpulse-monorepo/interfaces";

async function getContactById(contactId: string): Promise<IContact | null> {
  try {
    const db = firestore;

    const contactDocRef = await getDoc(
      doc(db, FirestoreCollections.contacts, contactId)
    );

    if (!contactDocRef.exists()) {
      return null;
    }

    const contact = contactDocRef.data() as IContact;

    return contact;
  } catch (e) {
    console.log("error: ", e);
    throw new GetContactByIdFailure();
  }
}

export class GetContactByIdFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getContactById;
